import { render } from "./AuCountdown.vue?vue&type=template&id=52a1eabd&scoped=true"
import script from "./AuCountdown.vue?vue&type=script&lang=js"
export * from "./AuCountdown.vue?vue&type=script&lang=js"

import "./AuCountdown.vue?vue&type=style&index=0&id=52a1eabd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52a1eabd"]])

export default __exports__